// src/RootApp.js
import React, { Suspense } from "react";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import "./i18n/index.js";

// ✅ default import จากไฟล์ที่ export default
import SettingsProvider from "./context/SettingsContext.jsx";

import HomePage from "./pages/HomePage.jsx";
import BooksPage from "./pages/BooksPage.js";
import BookArticlesPage from "./pages/BookArticlesPage.jsx";
import BookArticleDetail from "./pages/BookArticleDetail.jsx";
import ReaderPage from "./pages/ReaderPage.jsx";
import ContactPage from './pages/contact';
import AboutPage from './pages/about';
import LannaCraftsPage from "./pages/LannaCraftsPage.jsx";
import VolunteerHistoryPage from "./pages/VolunteerHistoryPage.jsx";
import TempleExhibitionPage from "./pages/TempleExhibitionPage.jsx";
import FacebookActivitiesPage from "./pages/FacebookActivitiesPage.jsx";
import RareBooksArticlePage from "./pages/RareBooksArticlePage.jsx";
import InthakinArticlePage from "./pages/InthakinArticlePage.jsx";
import WatUmongArticlePage from "./pages/WatUmongArticlePage.jsx";

// ✅ หน้า AR Guide (เพิ่มใหม่)
import ArGuidePage from "./pages/ArGuidePage.jsx";
import FaceSwapPage from './pages/face-swap';

import WebPortal from "./pages/WebPortal.jsx";

// ✅ หน้าที่เพิ่มใหม่ (มรดกความทรงจำแห่งโลก และ มรดกโลก)
import MemoryOfTheWorldPage from "./pages/MemoryOfTheWorldPage.jsx";
import WorldHeritagePage from "./pages/WorldHeritagePage.jsx";

// ✅ หน้าเกม
import GamesHubPage from './pages/GamesHubPage.jsx';
import SeamsiGamePage from './pages/SeamsiGamePage';
import DustCleanerGamePage from './pages/DustCleanerGamePage';
import TungCatcherGamePage from './pages/TungCatcherGamePage';
import PagodaStackerGamePage from './pages/PagodaStackerGamePage';
import ScriptTracingGamePage from './pages/ScriptTracingGamePage';
import PathRecorderPage from "./pages/PathRecorderPage.jsx";
import RoseRainGame from './pages/RoseRainGame';
import MatanapathaStoryPage from './pages/MatanapathaStoryPage';
import MattanaGame from "./pages/MattanaGame.jsx";
import CanvaGamePage from './pages/CanvaGamePage';
import LannaChefGamePage from './pages/LannaChefGamePage';
import RegionalChefGamePage from './pages/RegionalChefGamePage.jsx';

export default function RootApp() {
  return (
    <SettingsProvider>
      <Suspense
        fallback={
          <div className="p-6 text-center text-gray-600">
            Loading…
          </div>
        }
      >
        <BrowserRouter>
          <Routes>
            <Route path="/" element={<HomePage />} />

            {/* ✅ หน้า Web Portal (แหล่งสืบค้นทรัพยากร) */}
            <Route path="/portal" element={<WebPortal />} />

            {/* ✅ หน้าที่เพิ่มใหม่ */}
            <Route path="/memory-of-the-world" element={<MemoryOfTheWorldPage />} />
            <Route path="/world-heritage" element={<WorldHeritagePage />} />

            {/* หน้าหนังสือ / ค้นหาทรัพยากร */}
            <Route path="/books" element={<BooksPage />} />
            <Route path="/books/:view" element={<BooksPage />} />
            <Route path="/read/:id" element={<ReaderPage />} />

            {/* หน้าบทความแนะนำหนังสือ / รายละเอียดบทความ */}
            <Route path="/articles" element={<BookArticlesPage />} />
            <Route path="/book/:id" element={<BookArticleDetail />} />
            <Route path="/volunteer-history" element={<VolunteerHistoryPage />} />
            {/* หน้าบทความ “ช่างล้านนา” */}
            <Route path="/lanna-crafts" element={<LannaCraftsPage />} />
            <Route path="/rare-books-lanna" element={<RareBooksArticlePage />} />
            <Route path="/inthakin-article" element={<InthakinArticlePage />} />
            <Route path="/wat-umong-article" element={<WatUmongArticlePage />} />
            
            {/* แผนที่นิทรรศการวัดเชียงใหม่ */}
            <Route
              path="/temple-exhibition"
              element={<TempleExhibitionPage />}
            />

            {/* ✅ หน้า AR Guide */}
            <Route path="/ar-guide" element={<ArGuidePage />} />

            {/* ✅ หน้าใหม่: รวมกิจกรรม/ข่าวจาก Facebook */}
            <Route
              path="/facebook/activities"
              element={<FacebookActivitiesPage />}
            />
            <Route path="/contact" element={<ContactPage />} />
            <Route path="/about" element={<AboutPage />} />
            
            {/* เกม */}
            <Route path="/face-swap" element={<FaceSwapPage />} />
            <Route
              path="/games"
              element={<GamesHubPage />}
            />
            <Route
              path="/games/seamsi-game"
              element={<SeamsiGamePage />}
            />
            <Route
              path="/games/dust-cleaner-game"
              element={<DustCleanerGamePage />}
            />
            <Route
              path="/games/tung-catcher-game"
              element={<TungCatcherGamePage />}
            />
            <Route
              path="/games/pagoda-stacker-game"
              element={<PagodaStackerGamePage />}
            />
            <Route
              path="/games/script-tracing-game"
              element={<ScriptTracingGamePage />}
            />
            <Route
              path="/games/path-recorder"
              element={<PathRecorderPage />}
            />
            <Route
              path="/games/rose-rain-game"
              element={<RoseRainGame />}
            />
            <Route
              path="/games/matanapatha"
              element={<MatanapathaStoryPage />}
            />
            <Route
              path="/games/mattana-garden"
              element={<MattanaGame />}
            />
            <Route
              path="/games/regional-chef"
              element={<RegionalChefGamePage />}
            />
            <Route path="/games/lanna-chef" element={<LannaChefGamePage />} />
            <Route path="/games/lanna-food" element={<CanvaGamePage />} />
            
          </Routes>
        </BrowserRouter>
      </Suspense>
    </SettingsProvider>
  );
}